/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod";
import { safeParse } from "../../lib/schemas.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";
import {
  Meta,
  Meta$inboundSchema,
  Meta$Outbound,
  Meta$outboundSchema,
} from "./meta.js";
import {
  Pagination,
  Pagination$inboundSchema,
  Pagination$Outbound,
  Pagination$outboundSchema,
} from "./pagination.js";
import {
  RatelimitOverride,
  RatelimitOverride$inboundSchema,
  RatelimitOverride$Outbound,
  RatelimitOverride$outboundSchema,
} from "./ratelimitoverride.js";

export type V2RatelimitListOverridesResponseBody = {
  meta: Meta;
  data: Array<RatelimitOverride>;
  pagination?: Pagination | undefined;
};

/** @internal */
export const V2RatelimitListOverridesResponseBody$inboundSchema: z.ZodType<
  V2RatelimitListOverridesResponseBody,
  z.ZodTypeDef,
  unknown
> = z.object({
  meta: Meta$inboundSchema,
  data: z.array(RatelimitOverride$inboundSchema),
  pagination: Pagination$inboundSchema.optional(),
});

/** @internal */
export type V2RatelimitListOverridesResponseBody$Outbound = {
  meta: Meta$Outbound;
  data: Array<RatelimitOverride$Outbound>;
  pagination?: Pagination$Outbound | undefined;
};

/** @internal */
export const V2RatelimitListOverridesResponseBody$outboundSchema: z.ZodType<
  V2RatelimitListOverridesResponseBody$Outbound,
  z.ZodTypeDef,
  V2RatelimitListOverridesResponseBody
> = z.object({
  meta: Meta$outboundSchema,
  data: z.array(RatelimitOverride$outboundSchema),
  pagination: Pagination$outboundSchema.optional(),
});

/**
 * @internal
 * @deprecated This namespace will be removed in future versions. Use schemas and types that are exported directly from this module.
 */
export namespace V2RatelimitListOverridesResponseBody$ {
  /** @deprecated use `V2RatelimitListOverridesResponseBody$inboundSchema` instead. */
  export const inboundSchema =
    V2RatelimitListOverridesResponseBody$inboundSchema;
  /** @deprecated use `V2RatelimitListOverridesResponseBody$outboundSchema` instead. */
  export const outboundSchema =
    V2RatelimitListOverridesResponseBody$outboundSchema;
  /** @deprecated use `V2RatelimitListOverridesResponseBody$Outbound` instead. */
  export type Outbound = V2RatelimitListOverridesResponseBody$Outbound;
}

export function v2RatelimitListOverridesResponseBodyToJSON(
  v2RatelimitListOverridesResponseBody: V2RatelimitListOverridesResponseBody,
): string {
  return JSON.stringify(
    V2RatelimitListOverridesResponseBody$outboundSchema.parse(
      v2RatelimitListOverridesResponseBody,
    ),
  );
}

export function v2RatelimitListOverridesResponseBodyFromJSON(
  jsonString: string,
): SafeParseResult<V2RatelimitListOverridesResponseBody, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) =>
      V2RatelimitListOverridesResponseBody$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'V2RatelimitListOverridesResponseBody' from JSON`,
  );
}
